const opacity = {
  '0': '0',
  '25': '0.25',
  '75': '0.75',
  '10': '0.1',
  '20': '0.2',
  '30': '0.3',
  '40': '0.4',
  '50': '0.5',
  '60': '0.6',
  '70': '0.7',
  '80': '0.8',
  '90': '0.9',
  '100': '1',
};
export default opacity;
